export default __webpack_public_path__ + "static/media/announcement-logo.86190bf4.png";